import Navbar from "./Navbar";
import Lex from './Lex';
import ICG from "./ICG";

const Render = () => {
  return (
    <>
      <Navbar />
      <br />
      <br />
      <Lex />
    </>
  )
}

export default Render
